import { DocumentReference } from "@angular/fire/firestore";
import { CalendarEventBuilder } from "../builders/calendar-event.builder";
import {
  ProductSharedSettings,
  ProductInventorySettings,
  ProductAdvancedSettings
} from "../product/models";

import * as firebase from "firebase";

export class CalendarEvent {
  public readonly reference: DocumentReference;
  public readonly sold: number;
  public readonly date: Date;
  public readonly shared: ProductSharedSettings;
  public readonly inventory: ProductInventorySettings;
  public readonly advanced: ProductAdvancedSettings;

  constructor(builder: CalendarEventBuilder) {
    this.reference = builder.reference;
    this.sold = builder.sold;
    this.date = builder.date;
    this.shared = new ProductSharedSettings(builder.shared);
    this.advanced = new ProductAdvancedSettings(builder.advanced);
    this.inventory = new ProductInventorySettings(builder.inventory);
  }

  toJSON() {
    let event = {
      sold: this.sold ? this.sold : 0,
      date: firebase.firestore.Timestamp.fromDate(this.date),
      shared: this.shared.toJSON(),
      advanced: this.advanced.toJSON(),
      inventory: this.inventory.toJSON()
    };
    delete event.shared.type;
    delete event.shared.name;
    delete event.shared.isActive;
    return event;
  }

  get id(): string {
    return this.reference.id;
  }

  get path(): string {
    return this.reference.path;
  }
}
